/**
 * @param {DataSearchTerm[] | undefined} [terms]
 * @returns {Record<string, string>}
 */
function mapSelectBoxOptions(terms) {
  return terms
    ? terms.reduce(
        (options, term) => ({
          ...options,
          [term.id]: term.label,
        }),
        {},
      )
    : {};
}

export default mapSelectBoxOptions;
